import { NgModule } from "@angular/core";
import { DraggableComponent } from "./draggable.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule
  ],
  declarations: [
    DraggableComponent
  ],
  exports: [
    DraggableComponent
  ]
})
export class DraggableModule {}